import { Dispatch, FC, SetStateAction, useContext } from "react";
import { IInputComponentProps, Input } from "../../Elements/Input";
import { useTranslation } from "react-i18next";
import { deleteProps } from "@inceptionbg/ui-components";
import { Dialog } from "../../Elements/Dialog";
import { getLandsOptions } from "../../utils/LoadOptions";
import { SelectAsyncPaginate } from "../../Components/Inputs/SelectAsyncPaginate";
import { FarmContext } from "../../AppContent";
import { IFieldLand } from "../../types/IFieldBook";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data?: Partial<IFieldLand>;
  setData: Dispatch<SetStateAction<Partial<IFieldLand>>>;
  onSubmit: () => void;
  onDelete?: () => void;
  isDeletable?: boolean;
}
export const FieldLandDialog: FC<Props> = ({
  isOpen,
  onClose,
  data,
  setData,
  onSubmit,
  onDelete,
  isDeletable,
}) => {
  const { t } = useTranslation();
  const farmUuid = useContext(FarmContext).farm?.uuid!;

  const formInfo: IInputComponentProps[] = [
    {
      label: t("Land"),
      input: (
        <SelectAsyncPaginate
          required
          value={
            !!data?.land
              ? {
                  label: data.land.nickname || "/",
                  value: data.land.uuid,
                }
              : null
          }
          loadOptions={(
            search: string,
            loadedOptions: [],
            offset: { page: number }
          ) =>
            getLandsOptions(search, loadedOptions, offset, farmUuid, [], {
              approved: true,
              excludeUsedLands: true,
              excludeDeleteOnLandApproveLands: true,
            })
          }
          onChange={(e) =>
            setData(
              e
                ? {
                    ...data,
                    land: { nickname: e.label, uuid: e.value },
                  }
                : deleteProps(data, ["land"])
            )
          }
        />
      ),
    },
  ];

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={t("AddFieldLand")}
      confirmButton={{
        onFormSubmit: onSubmit,
        label: isDeletable ? t("Edit") : t("Confirm"),
      }}
      cancelButton={{ onClick: onClose }}
      deleteButton={
        isDeletable ? { onClick: onDelete, label: t("Remove") } : undefined
      }
      size="m"
    >
      <div className="flex column gap-4">
        {formInfo.map((e) => (
          <Input key={e.label} component={e} edit />
        ))}
      </div>
    </Dialog>
  );
};
